import { render } from "./2.RealEstate.vue?vue&type=template&id=644de6fc&scoped=true"
import script from "./2.RealEstate.vue?vue&type=script&lang=js"
export * from "./2.RealEstate.vue?vue&type=script&lang=js"

import "./2.RealEstate.vue?vue&type=style&index=0&id=644de6fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644de6fc"]])

export default __exports__